import { useEffect } from 'react';
import Lenis from 'lenis';

export const useLenis = () => {
  useEffect(() => {
    // Initialiser Lenis avec des paramètres optimisés
    const lenis = new Lenis({
      duration: 1.6,        // Durée de l'animation en secondes
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Easing personnalisé
      smoothWheel: true,     // Smooth scroll avec la molette
      smoothTouch: false,    // Désactiver sur mobile pour éviter les conflits
      touchMultiplier: 2,    // Multiplicateur pour le touch
      infinite: false,       // Pas de scroll infini
    });

    // Fonction de mise à jour de l'animation
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    // Démarrer l'animation
    requestAnimationFrame(raf);

    // Fonction de nettoyage
    return () => {
      lenis.destroy();
    };
  }, []);
};